import React from 'react';
import { useMediaQuery } from 'react-responsive';
import './IntegratedSoftware.css';

import xero from '../../../assets/journaler/NewJournaler/xero.png';
import quickbooks from '../../../assets/journaler/NewJournaler/quickbooks.svg';
import hashkey from '../../../assets/journaler/NewJournaler/hashkey.png';
import bybit from '../../../assets/journaler/NewJournaler/bybit.png';
import metamask from '../../../assets/home/integrateSoftware/metamask.png';
import coinbase from '../../../assets/journaler/NewJournaler/coinbase.svg';
import xverse from '../../../assets/home/integrateSoftware/x-verse.png';
import binance from '../../../assets/journaler/NewJournaler/binance.svg';
import fireblock from '../../../assets/journaler/NewJournaler/fireblock.png';
import safe from '../../../assets/journaler/NewJournaler/safe.png';

const INTEGRATED_LOGOS = [
    {
        img: xero,
        imgMobile: xero,
        alt: 'Xero',
        link: 'https://www.xero.com/au/',
        desktopStyle: { maxWidth: '80px', maxHeight: '80px' },
        mobileStyle: { maxWidth: '55px', maxHeight: '54px' }
    },
    {
        img: quickbooks,
        imgMobile: quickbooks,
        alt: 'QuickBooks',
        link: 'https://quickbooks.intuit.com/au/',
        opacity: 0.95,
        desktopStyle: { maxWidth: '120px', maxHeight: '40px' },
        mobileStyle: { maxWidth: '83px', maxHeight: '22px' }
    },
    {
        img: hashkey,
        imgMobile: hashkey,
        alt: 'HashKey Exchange',
        link: 'https://www.hashkey.com/en-US',
        desktopStyle: { maxWidth: '120px', maxHeight: '80px' },
        mobileStyle: { maxWidth: '74px', maxHeight: '66px' }
    },
    {
        img: bybit,
        imgMobile: bybit,
        alt: 'Bybit',
        link: 'https://www.bybit.com/',
        desktopStyle: { maxWidth: '120px', maxHeight: '90px' },
        mobileStyle: { maxWidth: '80px', maxHeight: '66px' }
    },
    {
        img: metamask,
        imgMobile: metamask,
        alt: 'MetaMask',
        link: 'https://metamask.io/',
        desktopStyle: { maxWidth: '122px', maxHeight: '69px' },
        mobileStyle: { maxWidth: '83px', maxHeight: '47px' }
    },
    {
        img: coinbase,
        imgMobile: coinbase,
        alt: 'Coinbase',
        link: 'https://www.coinbase.com/au',
        desktopStyle: { maxWidth: '100px', maxHeight: '62px' },
        mobileStyle: { maxWidth: '68px', maxHeight: '42px' }
    },
    {
        img: xverse,
        imgMobile: xverse,
        alt: 'Xverse',
        link: 'https://www.xverse.app/',
        desktopStyle: { maxWidth: '103px', maxHeight: '69px' },
        mobileStyle: { maxWidth: '70px', maxHeight: '47px' }
    },
    {
        img: binance,
        imgMobile: binance,
        alt: 'Binance',
        link: 'https://www.binance.com/en',
        desktopStyle: { maxWidth: '130px', maxHeight: '107px' },
        mobileStyle: { maxWidth: '84px', maxHeight: '80px' }
    },
    {
        img: fireblock,
        imgMobile: fireblock,
        alt: 'Fireblocks',
        link: 'https://www.fireblocks.com/',
        desktopStyle: { maxWidth: '150px', maxHeight: '120px' },
        mobileStyle: { maxWidth: '110px', maxHeight: '80px' }
    },
    {
        img: safe,
        imgMobile: safe,
        alt: 'Safe',
        link: 'https://safe.global/',
        desktopStyle: { maxWidth: '108px', maxHeight: '40px' },
        mobileStyle: { maxWidth: '70px', maxHeight: '28px' }
    }
];

function logosForViewport(isMobileView) {
    if (!isMobileView) return INTEGRATED_LOGOS;
    const next = [...INTEGRATED_LOGOS];
    const coinbaseIdx = next.findIndex((l) => l.alt === 'Coinbase');
    const xverseIdx = next.findIndex((l) => l.alt === 'Xverse');
    if (coinbaseIdx !== -1 && xverseIdx !== -1) {
        [next[coinbaseIdx], next[xverseIdx]] = [next[xverseIdx], next[coinbaseIdx]];
    }
    return next;
}

const IntegratedSoftware = ({ showLearnMore = true }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const logos = logosForViewport(isMobile);

    const handleLearnMore = (e) => {
        e.preventDefault();
        window.location.href = '/journaler/integration';
    };

    const logosLayoutClass = isMobile ? 'integrated-software-logos--mobile' : 'integrated-software-logos--desktop';

    return (
        <div className="integrated-software-container">
            <h2 className="integrated-software-title">Integrated Software</h2>

            <div className={`integrated-software-logos ${logosLayoutClass}`}>
                {logos.map((logo, index) => (
                    <div
                        key={logo.alt}
                        className={`integrated-software-logo-wrapper`}
                    >
                        <a
                            href={logo.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="integrated-software-logo-link"
                        >
                            <img
                                src={isMobile ? logo.imgMobile : logo.img}
                                alt={logo.alt}
                                className="integrated-software-logo"
                                style={{
                                    ...(isMobile ? logo.mobileStyle : logo.desktopStyle),
                                    opacity: logo.opacity ?? 1
                                }}
                            />
                        </a>
                    </div>
                ))}
            </div>

            {showLearnMore && (
                <button className="integrated-software-button" onClick={handleLearnMore}>
                    Learn more
                </button>
            )}
        </div>
    );
};

export default IntegratedSoftware;
